import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import PTZControls from '../settings/PTZControls';
import $ from "jquery";
import Toastr from 'toastr';
import SessionManager from '../../routes/SessionManager';
import CommonUtils from "../../util/CommonUtils";
import bootbox from 'bootbox';
import { Input } from "antd";
import LZString from 'lz-string';
import Hls from 'hls.js';
import moment from 'moment';
import XMLParser from 'react-xml-parser';

const AxisLiveCameraFeed = ({ zone, site, closeModal }) => {
    const [user, setUser] = useState(() => {
        const sessionManager = new SessionManager();
        const userCookie = sessionManager.readCookie('user', true);
        const zoneSelected = zone || userCookie.zones.find(z => z.location_id === zone.location_id);
        const siteSelected = site || userCookie.site_selected;
        return { ...userCookie, zone_selected: zoneSelected, site_selected: siteSelected };
    });

    const [showingControls, setShowingControls] = useState(false);
    const [ptzModified, setPtzModified] = useState(null);
    const [recordings, setRecordings] = useState(null);

    const timezone = user.site_selected.site_iana_timezone;
    const startTs = useRef(moment.utc());
    const endTs = useRef(null);

    const videoRef = useRef(null);
    const hlsRef = useRef(null);
    const streamTimerRef = useRef(null);
    const timeLeftTimerRef = useRef(null);

    const axisMaxStreamSession = 5 * 60 * 1000;

    const deviceLockInterval = 5 * 60 * 1000;
    const waitTimeForExtendTimer = 1 * 60 * 1000;

    const clearAllTimeouts = () => {
        var id = setTimeout(function () { }, 0);
        while (id--) {
            if (id !== streamTimerRef.current)
                clearTimeout(id); // will do nothing if no timeout with id is present
        }
    }

    useEffect(() => {
        getRecordingId();
        return () => {
            clearInterval(timeLeftTimerRef.current);
            clearTimeout(streamTimerRef.current);
        };
    }, []);

    useEffect(() => {
        const browserAgent = navigator.userAgent.toUpperCase();
        const iOS = browserAgent.includes('IPAD') || browserAgent.includes('IPHONE');

        if (iOS) {
            hlsPlayer();
        } else {
            msePlayer();
        }
    }, []);

    const msePlayer = useCallback(() => {
        const mseQueue = []
        let mseSourceBuffer
        let mseStreamingStarted = false;
        function Utf8ArrayToStr(array) {
            var out, i, len, c;
            var char2, char3;
            out = "";
            len = array.length;
            i = 0;
            while (i < len) {
                c = array[i++];
                switch (c >> 4) {
                    case 7:
                        out += String.fromCharCode(c);
                        break;
                    case 13:
                        char2 = array[i++];
                        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                        break;
                    case 14:
                        char2 = array[i++];
                        char3 = array[i++];
                        out += String.fromCharCode(((c & 0x0F) << 12) |
                            ((char2 & 0x3F) << 6) |
                            ((char3 & 0x3F) << 0));
                        break;

                    default:
                        break;
                }
            }
            return out;
        }

        function startPlay(videoEl, url) {
            try {
                const mse = new MediaSource()
                videoEl.src = window.URL.createObjectURL(mse)
                mse.addEventListener('sourceopen', function () {
                    const ws = new WebSocket(url);
                    videoRef.current.ws = ws;
                    ws.binaryType = 'arraybuffer'
                    videoEl.ws = ws;
                    ws.onopen = function (event) {
                        console.log('Connect to ws')
                    }
                    ws.onmessage = function (event) {
                        const data = new Uint8Array(event.data)
                        if (data[0] === 9) {
                            let mimeCodec
                            const decodedArr = data.slice(1)
                            if (window.TextDecoder) {
                                mimeCodec = new TextDecoder('utf-8').decode(decodedArr)
                            } else {
                                mimeCodec = Utf8ArrayToStr(decodedArr)
                            }
                            mseSourceBuffer = mse.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"')
                            mseSourceBuffer.mode = 'segments'
                            mseSourceBuffer.addEventListener('updateend', pushPacket)
                        } else {
                            readPacket(event.data)
                        }
                    }
                }, false)
            } catch (error) {
                console.log(error);
            }
        }

        function pushPacket() {
            try {
                const videoEl = document.querySelector('#axis-video')
                let packet

                if (!mseSourceBuffer.updating) {
                    if (mseQueue.length > 0) {
                        packet = mseQueue.shift()
                        mseSourceBuffer.appendBuffer(packet)
                    } else {
                        mseStreamingStarted = false
                    }
                }
                if (videoEl && videoEl.buffered.length > 0) {
                    if (typeof document.hidden !== 'undefined' && document.hidden) {
                        // no sound, browser paused video without sound in background
                        videoEl.currentTime = videoEl.buffered.end((videoEl.buffered.length - 1)) - 0.5
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        function readPacket(packet) {
            try {
                if (!mseStreamingStarted) {
                    mseSourceBuffer.appendBuffer(packet)
                    mseStreamingStarted = true
                    return
                }
                mseQueue.push(packet)
                if (!mseSourceBuffer.updating) {
                    pushPacket()
                }
            } catch (error) {
                console.log(error)
            }
        }
        const videoEl = document.querySelector('#axis-video');

        let uuid = LZString.compressToBase64(user.user_login + " " + user.user_token);
        const mseUrl = "wss://rtsp.sitesuptondemand.com/stream/" + (zone.device_id) + "/channel/0/mse?uuid=" + encodeURIComponent(uuid);

        // fix stalled video in safari
        videoEl.addEventListener('pause', () => {
            try {
                if (videoEl.currentTime > videoEl.buffered.end(videoEl.buffered.length - 1)) {
                    videoEl.currentTime = videoEl.buffered.end(videoEl.buffered.length - 1) - 0.1
                    videoEl.play();
                }
            } catch (error) { }
        })

        startPlay(videoEl, mseUrl)
    }, [user, zone]);

    const isDeviceControlsLockAcquireAllowed = async () => {
        let location = await CommonUtils.getLocation(zone.location_id, user);
        let allowed = !location.device_ctrl_lock ||
            location.device_ctrl_lock === null ||
            location.device_ctrl_lock === undefined ||
            location.device_ctrl_lock === user.user_login || // if same user login
            (location.device_ctrl_lock_expiry + waitTimeForExtendTimer) < new Date().valueOf();

        if (!allowed) {
            Toastr.info('Device is now in use by ' + location.device_ctrl_lock + ', \nPlease try again after sometime ...');
            console.log('Till', new Date(location.device_ctrl_lock_expiry));
        }
        return allowed;
    }

    const acquireDeviceControlsLock = async () => {
        let location_latest = await CommonUtils.saveLocation({
            location_id: zone.location_id,
            site_id: zone.site_id,
            device_ctrl_lock: user.user_login,
            device_ctrl_lock_expiry: new Date().valueOf() + (deviceLockInterval)
        }, user);

        setTimeout(() => {
            setTimeout(() => {
                $('.close-device-lock-bb').trigger('click');
            }, waitTimeForExtendTimer);

            bootbox.dialog({
                html: true,
                closeButton: false,
                message: "Do you need some more time to save changes ? <br><small class='text-danger'>Resets changes if there’s no response within a minute.</small>",
                buttons: {
                    cancel: {
                        label: 'Reset Changes',
                        className: 'btn btn-sm btn-default close-device-lock-bb',
                        callback: function (isYes) {
                            setShowingControls(false);
                            releaseDeviceControlsLock();
                            go2Home();
                        }
                    },
                    confirm: {
                        label: 'Extend Timer',
                        className: 'btn btn-sm btn-success',
                        callback: function (isYes) {
                            clearAllTimeouts();
                            acquireDeviceControlsLock();
                        }
                    }
                }
            });

        }, deviceLockInterval);

        if (location_latest) {
            user.zone_selected = { ...user.zone_selected, ...location_latest };
            setUser(user);
        }

        return zone;
    }

    const releaseDeviceControlsLock = async () => {

        clearAllTimeouts();
        let location_latest = await CommonUtils.saveLocation({
            location_id: zone.location_id,
            site_id: zone.site_id,
            device_ctrl_lock: null,
            device_ctrl_lock_expiry: 0
        }, user);

        if (location_latest) {
            user.zone_selected = { ...user.zone_selected, ...location_latest };
            setUser(user);
        }
        return zone;
    }

    const startTimerToStop = useCallback(() => {
        let videoId = '#LIVE_CAM_' + user.zone_selected.location_id;

        if ($(videoId) && $(videoId).length > 0) {
            $(videoId).find('video')[0].style.maxHeight = '';
            $(videoId).closest('.modal-body').find('.message-container').addClass('hide');
        }

        clearInterval(timeLeftTimerRef.current);
        clearTimeout(streamTimerRef.current);

        streamTimerRef.current = setTimeout(() => {

            let ctr = (waitTimeForExtendTimer / 1000); // 60secs
            $('#time_left').html('');
            timeLeftTimerRef.current = setInterval(() => {
                if (ctr < 0 && $('#close-player')) {
                    handleSaveVideScenario(closeStreamConfirmBb);
                }
                if ($('#time_left')) {
                    $('#time_left').html(ctr--);
                }
            }, 1000);

            let closeStreamConfirmBb = bootbox.dialog({
                closeButton: false,
                message: `<b>Would you like to continue viewing this stream ?</b> <br><br> 
                <div class="font-size-12">
                    <ul>
                        <li>Clicking 'Yes' will allow to continue viewing this stream for next 5 minutes.</li>
                        <li>Streaming stops if not responded in next <span id="time_left">30</span> secs.</li>
                    </ul>
                </div>
                `,
                buttons: [
                    {
                        callback: () => {
                            clearInterval(timeLeftTimerRef.current);
                            clearTimeout(streamTimerRef.current);
                            if ($('.streaming-btn'))
                                $('.streaming-btn').trigger('click');

                            if ($('#close-player')) {
                                $('#close-player').trigger('click');
                            }
                            return true;
                        }, label: 'No'
                    },
                    {
                        callback: () => {
                            clearInterval(timeLeftTimerRef.current);
                            clearTimeout(streamTimerRef.current);
                            startTimerToStop();
                            return true;
                        }, label: 'Yes'
                    }
                ]
            }, () => console.log('opened confirm box'));

        }, axisMaxStreamSession);

    }, [user]);

    const handleSaveVideScenario = (closeStreamConfirmBb) => {
        if (closeStreamConfirmBb && closeStreamConfirmBb.is(':visible')) {
            try {
                closeStreamConfirmBb.modal('hide');
                if ($('.streaming-btn'))
                    $('.streaming-btn').trigger('click');
            } catch (error) { }
            if ($('#close-player')) {
                $('#close-player').trigger('click');
            }
        }
    }

    const hlsPlayer = useCallback(() => {
        if (!hlsRef.current && Hls.isSupported()) {
            hlsRef.current = new Hls();
        }

        let uuid = LZString.compressToBase64(user.user_login + " " + user.user_token);
        const hlsUrl = "https://rtsp.sitesuptondemand.com/stream/" + (zone.device_id) + "/channel/0/hls/live/index.m3u8?uuid=" + encodeURIComponent(uuid);

        if ($("#axis-video").length === 0) { // not loaded yet
            setTimeout(() => {
                hlsPlayer();
            }, 2000);
            return;
        }

        if ($("#axis-video")[0].canPlayType('application/vnd.apple.mpegurl')) {
            $("#axis-video")[0].src = hlsUrl;
            $("#axis-video")[0].load();

            let isPlayingOnIOS = false;
            $("#axis-video")[0].onplaying = function () {
                isPlayingOnIOS = true;
            }

            setTimeout(() => {
                if (!isPlayingOnIOS) {
                    hlsPlayer();
                }
            }, 10000);

        } else {
            if (hlsRef.current) {
                hlsRef.current.loadSource(hlsUrl);
                hlsRef.current.attachMedia($("#axis-video")[0]);
            } else {
                Toastr.error('Your browser is not supported to play the stream')
            }
        }
    }, [user, zone]);

    const savePTZPresets = useCallback(async (presetDetails, isNew) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/" + (isNew ? "save-preset" : "modify-preset"),
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    location_id: zone.location_id,
                    device_id: zone.device_id,
                    user_login: user.user_login,
                    user_token: user.user_token,
                    form_input: presetDetails
                }),
                success: function (response) {
                    if (response.status && response.status.code === 200)
                        resolve(response.data)
                    else
                        resolve([])
                },
                error: function (xhr, status) {
                    resolve([])
                }
            });
        });
    }, [user, zone]);

    const go2Home = useCallback(async () => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/go2home",
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    location_id: zone.location_id,
                    device_id: zone.device_id,
                    user_login: user.user_login,
                    user_token: user.user_token,
                    form_input: {
                        location_id: zone.location_id,
                        site_id: user.site_selected.site_id,
                        ptz_op: 'to_home'
                    }
                }),
                success: function (response) {
                    if (response.status && response.status.code === 200)
                        resolve(response.data)
                    else
                        resolve([])
                },
                error: function (xhr, status) {
                    resolve([])
                }
            });
        });
    }, [user, zone]);

    const togglePTZControls = useCallback(async (e, isClose = false) => {
        if (e)
            e.preventDefault();

        if (isClose) {
            clearInterval(timeLeftTimerRef.current);
            clearTimeout(streamTimerRef.current);
        }

        $('.controls-btn').attr('disabled', true);
        let zone = user.zone_selected;
        Toastr.clear();
        if (!showingControls && !isClose) {
            let allowed = await isDeviceControlsLockAcquireAllowed();
            if (allowed !== true) {
                $('.controls-btn').attr('disabled', false);
                return;
            }
            if (allowed === true)
                await acquireDeviceControlsLock();
        } else {
            if (zone.device_ctrl_lock && zone.device_ctrl_lock === user.user_login) {
                await releaseDeviceControlsLock();
            }
        }

        $('.controls-btn').attr('disabled', false);
        setShowingControls(!showingControls);

        if (ptzModified) {
            const sessionManager = new SessionManager();
            const updatedUser = { ...user, zone_selected: zone };
            sessionManager.storeCookie('user', updatedUser);
            setUser(updatedUser);

            if (CommonUtils.hasPermission('SITESUPT-UI-PTZ-PRESET-MODIFY')) {
                if (!CommonUtils.hasPath(user.zone_selected, 'location_config.special_controls.ptz_camera')) {
                    const updatedUser = { ...user };
                    const zoneSelected = updatedUser.zone_selected;
                    if (!zoneSelected.location_config)
                        zoneSelected.location_config = {};

                    zoneSelected.location_config.special_controls = {
                        "ptz_camera": {
                            "enabled": false,
                            "presets": {},
                            "last_move": 0,
                            "last_preset": 0,
                            "home_default": "0"
                        }
                    };
                    updatedUser.zone_selected = zoneSelected;
                    setUser(updatedUser);
                }
                if (CommonUtils.hasPath(user.zone_selected, 'location_config.special_controls.ptz_camera')) {
                    const ptzCamera = user.zone_selected.location_config.special_controls.ptz_camera;
                    const locationPresets = zone.preset ? zone.preset : await getPTZPresets(zone);
                    const presetOptions = [];
                    let defaultPreset = null;
                    if (locationPresets && locationPresets.length > 0) {
                        for (let p of locationPresets) {
                            presetOptions.push({ label: <span className={p.preset_id === ptzCamera.home_default ? 'text-capitalize text-success' : 'text-capitalize text-app'}>{p.name}</span>, value: p.preset_id });
                            if (ptzCamera.home_default === p.preset_id)
                                defaultPreset = p;
                        }
                    }
                    console.log('defaultPreset ', defaultPreset);

                    let preset = { preset_name_new: '', preset_id_opted: 0 };
                    if (defaultPreset)
                        preset.preset_id_opted = defaultPreset.preset_id;

                    let presetSelector = <div className='text-left preset_container'>
                        <label className='text-primary'>Save as camera preset.</label>
                        <div className="p-2"><b>Preset Name:</b> {defaultPreset !== null ? "HOME (" + defaultPreset.name + ")" : <Input onBlur={(e) => preset.preset_name_new = e.currentTarget.value} id='preset_new' type="text" className='form-control' />}</div>
                    </div>;

                    let dialog = bootbox.dialog({
                        closeButton: false,
                        message: '<div id="preset_save">Loading ...</div>',
                        buttons: {
                            cancel: {
                                label: "Reset",
                                className: 'btn btn-sm btn-default btn-reset',
                                callback: function () {
                                    if (zone.device_ctrl_lock && zone.device_ctrl_lock === user.user_login)
                                        releaseDeviceControlsLock();
                                    go2Home();
                                }
                            },
                            ok: {
                                label: "Save",
                                className: 'btn btn-sm btn-primary btn-save',
                                callback: function () {
                                    let isNew = preset.preset_id_opted === 0;
                                    if (isNew && preset.preset_name_new.trim().length === 0) {
                                        Toastr.info("Preset Name can't be empty");
                                        return false;
                                    }

                                    let locationCurr = user.zone_selected;
                                    let presetIdNew = String(parseInt(locationCurr.location_id) + new Date().getTime());
                                    let active = true;

                                    let presetData = {
                                        location_id: locationCurr.location_id,
                                        preset_info: {},

                                        name: isNew ? preset.preset_name_new.trim() : null,
                                        preset_id: isNew ? presetIdNew : preset.preset_id_opted
                                    };

                                    let allowedAtts = ['pan', 'tilt', 'zoom', 'autofocus'];
                                    if (!ptzModified)
                                        return;

                                    for (let att of allowedAtts)
                                        if (ptzModified[att])
                                            presetData.preset_info[att] = ptzModified[att];

                                    if (CommonUtils.hasPath(locationCurr, 'location_config.feature_controls.motion_detection'))
                                        presetData.motion_detection = locationCurr.location_config.feature_controls.motion_detection;

                                    if (CommonUtils.hasPath(locationCurr, 'location_config.feature_controls.vtracking'))
                                        presetData.vtracking = locationCurr.location_config.feature_controls.vtracking;

                                    dialog.find(".btn-save").html('Saving ...');
                                    dialog.find(".btn-save")[0].disabled = true;

                                    savePTZPresets(presetData, isNew).then(async (response) => {
                                        //let location = await CommonUtils.getLocation(presetData.location_id, user);
                                        let location = await releaseDeviceControlsLock();
                                        console.log('location', location)

                                        if (!CommonUtils.hasPath(location, 'location_config.special_controls.ptz_camera')) {
                                            if (!location.location_config)
                                                location.location_config = {};

                                            location.location_config.special_controls = {
                                                "ptz_camera": {
                                                    "enabled": false,
                                                    "presets": {},
                                                    "last_move": 0,
                                                    "last_preset": 0,
                                                    "home_default": "0"
                                                }
                                            };
                                        }

                                        if (location && CommonUtils.hasPath(location, 'location_config.special_controls.ptz_camera')) {
                                            let presets = location.location_config.special_controls.ptz_camera.presets || {};

                                            if (presets && presets[presetData.preset_id]) {
                                                presets[presetData.preset_id] = {
                                                    homeable: true,
                                                    in_position: false,
                                                    schedule: "always",
                                                };
                                            } else {
                                                presets[presetData.preset_id] = {
                                                    homeable: true,
                                                    in_position: false,
                                                    schedule: "always",
                                                };
                                            }
                                            location.location_config.special_controls.ptz_camera.presets = presets;

                                            if (active) {
                                                location.location_config.special_controls.ptz_camera.home_default = presetData.preset_id;
                                                location.location_config.special_controls.ptz_camera.enabled = true;
                                            }

                                            let status = await CommonUtils.saveLocation({ location_id: location.location_id, site_id: location.site_id, location_config: location.location_config }, user);
                                            if (status) {
                                                location.location_config = status.location_config;
                                                const updatedUser = { ...user, zones: user.zones.map(l => l.location_id === location.location_id ? { ...l, location_config: status.location_config } : l), zone_selected: location };
                                                sessionManager.storeCookie('user', updatedUser);
                                                setUser(updatedUser);
                                                setPtzModified(null);
                                                Toastr.success('Preset saved successfully');
                                                dialog.find(".btn-save")[0].disabled = false;
                                                bootbox.hideAll();

                                                bootbox.confirm('Since you modified your camera preset, you will need to adjust your detection masks.', async (isYes) => {
                                                    if (isYes) {
                                                        saveVideo();
                                                        window.location = './site-management?fetchLatestImage=true#zone-settings';
                                                    }
                                                });

                                            } else {
                                                dialog.find(".btn-save")[0].disabled = false;
                                            }
                                        }

                                    })
                                    return false;
                                }
                            }
                        }
                    });

                    setTimeout(() => {
                        ReactDOM.render(presetSelector, document.getElementById('preset_save'));
                    }, 1000);

                }
            } else {
                go2Home();
            }
        }

    }, [ptzModified, user, zone, go2Home, savePTZPresets, showingControls]);


    const getPTZPresets = useCallback(async (zone) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/ptz-presets",
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    location_id: zone.location_id,
                    device_id: zone.device_id,
                    user_login: user.user_login,
                    user_token: user.user_token
                }),
                success: function (response) {
                    if (response.status && response.status.code === 200)
                        resolve(response.data)
                    else
                        resolve([])
                },
                error: function (xhr, status) {
                    resolve([])
                }
            });
        });
    }, [user]);

    const getRecordingId = useCallback(() => {
        $.ajax({
            url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/recordings",
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            headers: {
                user_login: user.user_login,
                user_token: user.user_token
            },
            data: JSON.stringify({ device_id: zone.device_id }),
            success: function (response) {
                if (response.status.code === 200) {
                    let recordingsJSON = new XMLParser().parseFromString(response.data);
                    let recordings = recordingsJSON.getElementsByTagName('recording');
                    console.log('recordings', recordings)
                    setRecordings(recordings);
                } else {
                    setRecordings(null)
                }
            },
            error: function (xhr, status) {
                setRecordings(null)
            }
        });
    }, [user, zone]);

    const saveVideo = useCallback(() => {
        clearTimeout(streamTimerRef.current);
        if (!recordings || recordings.length === 0) return;

        Toastr.success('Saving in progress...');
        endTs.current = moment.utc();

        const data = {
            live_video: true,
            device_id: zone.device_id,
            recordingid: recordings[0].attributes.recordingid,
            customer_id: zone.customer_id,
            location_id: zone.location_id,
            site_id: zone.site_id,
            start_ts: moment.tz(startTs.current, timezone).format('YYYY-MM-DDTHH:mm:ss'),
            end_ts: moment.tz(endTs.current, timezone).format('YYYY-MM-DDTHH:mm:ss'),
            sec_timestamp: zone.location_lastupdate / 1000,
            sec_timestamp_end: moment(endTs.current, 'YYYY-MM-DDTHH:mm:ss').diff(moment(startTs.current, 'YYYY-MM-DDTHH:mm:ss'), 'seconds'),
            user_login: user.user_login,
            user_token: user.user_token,
            timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            timestamp_to_tag: zone.location_lastupdate / 1000
        };

        $.ajax({
            url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/save-video",
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            headers: {
                user_login: user.user_login,
                user_token: user.user_token
            },
            data: JSON.stringify(data),
            success: function (response) {
                if (response.status.code === 200) {
                    Toastr.success('Video saved successfully');
                } else {
                    Toastr.error('Error saving video');
                }
            },
            error: function (xhr, status) {
                Toastr.error('Error saving video');
            }
        });
    }, [recordings, zone, user, timezone]);

    let allowControls = zone.location_device_type ? zone.location_device_type !== 'uniview' ? true : false : true;

    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{"Watch Streaming Video - " + zone.location_name}</span>
                <span className='pull-right'>
                    {allowControls && CommonUtils.hasPermission('SITESUPT-UI-PTZ-CTRLS') && (
                        <button type='button' className='btn btn-sm btn-white text-dark controls-btn' onClick={togglePTZControls}>
                            {showingControls ? 'Hide' : 'Show'} Controls
                        </button>
                    )}
                    <button id='close-player' type='button' className='far fa-lg fa-times-circle' data-dismiss='modal' onClick={() => {
                        if (videoRef.current) {
                            if (videoRef.current.ws) {
                                videoRef.current.ws.close(1000);
                                videoRef.current.ws = null;
                            }
                            videoRef.current.src = '';
                            videoRef.current.load();
                        }
                        if (hlsRef.current) {
                            hlsRef.current.destroy();
                            hlsRef.current = null;
                        }
                        saveVideo();
                        closeModal();
                        togglePTZControls(null, true);
                    }}></button>
                </span>
            </div>
            <div className="modal-body p-0" id={'LIVE_CAM_' + (zone.location_id)} >
                <div className="text-center message-container" style={{ padding: "200px 0px" }}>
                    <div>
                        <span className="border-rounded p-2 message bg-primary-light" >
                            <i className="fa fa-lg fa-spin fa-circle-notch text-app"></i> Preparing Streaming ...
                        </span><br />
                    </div>
                </div>
                <div>
                    <video
                        ref={videoRef}
                        onPlay={() => startTimerToStop()}
                        id="axis-video"
                        autoPlay
                        muted
                        playsInline
                        controls
                        style={{ width: "100%", "maxHeight": "0", overflowY: "hidden" }}
                    ></video>
                    <PTZControls
                        id={'PTZ' + (Math.floor((Math.random() * 10000000) + 1))}
                        show={showingControls}
                        user={user}
                        device_id={zone.device_id}
                        zone={zone}
                        setPtzNew={setPtzModified}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default AxisLiveCameraFeed;
